module.exports = __webpack_public_path__ + "static/media/IVh.2e060097.png";